export enum ShipmentItemErrorCodes {
  "ITEM_WEIGHT_EXCEEDS_PACKAGE_WEIGHT" = "ITEM_WEIGHT_EXCEEDS_PACKAGE_WEIGHT",
}
